module.exports = __webpack_public_path__ + "static/media/Optima.69c36d2c.woff";